import MobileNavContainer from './MobileNavContainer';

export default MobileNavContainer;
